/** Which face of the Decide page a player works in: the walk or the full sheet. One choice per player on this device (localStorage, every access guarded), kept across rounds and runs; the first visit is the walk. */
import { useCallback, useState } from "react";

export type Face = "walk" | "sheet";
/** The device-wide key of earlier versions: read as the default for a player who has not chosen yet, never written. */
export const FACE_KEY = "gx.decide.face";
export const faceKeyOf = (userId: string): string => `${FACE_KEY}.${userId}`;
/** The rule, said beside the switch. */
export const FACE_RULE = "Decide opens this way next time on this device.";

const read = (userId: string): Face => {
  try { return (window.localStorage.getItem(faceKeyOf(userId)) ?? window.localStorage.getItem(FACE_KEY)) === "sheet" ? "sheet" : "walk"; } catch { return "walk"; }
};

export function useFace(userId: string): { readonly face: Face; readonly setFace: (f: Face) => void } {
  const [face, set] = useState<Face>(() => read(userId));
  const setFace = useCallback((f: Face) => {
    set(f);
    try { window.localStorage.setItem(faceKeyOf(userId), f); } catch { /* per-device convenience only */ }
  }, [userId]);
  return { face, setFace };
}
